import {reactive} from "vue";

class AutorizacaoEvents {

    listenerCodigoGerado = reactive({value: {codigo: ""}})

    emitCodigoGerado(codigo:string):void {
        this.listenerCodigoGerado.value = {codigo: codigo}
    }
}

export default AutorizacaoEvents;